// extracted by mini-css-extract-plugin
module.exports = {"Graphic":"Hero_Graphic__2-Fwh","Text":"Hero_Text__3Bfqc","content":"Hero_content__34Qr9","Arrow":"Hero_Arrow__2_P5M","bounce":"Hero_bounce__2ktyS"};